<template><div><h1>VUX V2.2.1Rc.3 发布日志</h1>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[fix] 修复当值设为空数组时不会重新渲染的问题. #1230</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] 支持设置 取消 和 确定 文字. #1233</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.3 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.3-222.vue?1c086f18